import React from 'react';
import { Typography, Icon, BackButton, Button } from '../../components/index';
import store from 'store2';
import { Row, Col } from 'react-styled-flexboxgrid';
import Styled from './EasyWin.style';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
interface EasyWinProps {
  data: any;
  children?: any;
}

const EasyWin: React.FC<EasyWinProps> = (props) => {
  const { data, children } = props;
  const getLocationId = store('property');
  const navigate = useNavigate();
  const [copy, setCopy] = React.useState(false);

  if (copy !== false) {
    setTimeout(() => {
      setCopy(false);
    }, 2000);
  }

  const sizeProps = (size) => {
    switch (size) {
      case 'half':
        return {
          xs: 12,
          sm: 12,
          md: 6,
        };
      case 'full':
        return {
          xs: 12,
          sm: 12,
          md: 12,
        };
      case 'quarter':
        return {
          xs: 12,
          sm: 6,
          md: 3,
        };
      default:
        return {
          xs: 12,
          sm: 12,
        };
    }
  };

  const renderPage = () => {
    return _.map(data, (el) => {
      return (
        <div key={el.title}>
          <Styled.IntroWrap>
            <Styled.IconWrap>
              <Icon icon={el.icon} size={80} />
            </Styled.IconWrap>
            <div style={{ flex: 1 }}>
              <Typography size="1" text={el.title} />
              <Typography
                size="p"
                text={el.description}
                style={{ maxWidth: '600px' }}
              />
            </div>
            <BackButton />
          </Styled.IntroWrap>
          <Row>
            <Col md={12} xs={12} sm={12}>
              <Styled.NoLocationBanner>
                <Row>
                  <Col md={6} sm={12} xs={12}>
                    {' '}
                    <div
                      style={{
                        textAlign: 'center',
                        marginTop: '64px',
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: '30px',
                          width: '320px',
                          marginBottom: '24px',
                          color: 'white',
                        }}
                        size="1"
                        text="Review your actions and start saving water."
                      />
                      <Button
                        onClick={() => navigate(`/locations/${getLocationId}`)}
                        appearance="OUTLINED"
                        style={{
                          borderRadius: '32px',
                          textTransform: 'none',
                          padding: '8px 32px',
                        }}
                      >
                        Take action
                      </Button>
                    </div>
                  </Col>
                  <Col md={6} sm={12} xs={12}>
                    <img
                      src="https://cdn.getwaterfit.co.uk/static/files/images/circles.png"
                      alt="circles"
                    />
                  </Col>
                </Row>
              </Styled.NoLocationBanner>
            </Col>
          </Row>
          <Row>
            {el.easyWins.map((elem, index) => {
              return (
                <Col key={index} {...sizeProps(elem.size)}>
                  <Styled.Box theme={elem.theme}>
                    {elem.size === 'full' ? (
                      <div style={{ flex: 1 }}>
                        {elem.hasLogo ? (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              marginBottom: '16px',
                            }}
                          >
                            <Typography size="3" text={elem.title} />
                            <img
                              src={
                                'https://cdn.getwaterfit.co.uk/static/files/logos/gws-color.svg'
                              }
                              alt="GetWaterSmart"
                              width="200px"
                            />
                          </div>
                        ) : (
                          <Typography size="3" text={elem.title} />
                        )}
                        {elem.description.map((element, index) => {
                          return (
                            <Typography key={index} size="p" text={element} />
                          );
                        })}
                      </div>
                    ) : (
                      <div style={{ flex: 1, display: 'flex' }}>
                        <div>
                          {elem.hasLogo ? (
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px',
                              }}
                            >
                              <Typography
                                size="3"
                                text={elem.title}
                                style={{ margin: 0 }}
                              />
                              <img
                                src={
                                  'https://cdn.getwaterfit.co.uk/static/files/logos/gws-color.svg'
                                }
                                alt="GetWaterSmart"
                                width="200px"
                              />
                            </div>
                          ) : (
                            <Typography size="3" text={elem.title} />
                          )}
                          {elem.description && (
                            <div>
                              {elem.description.map((element, index) => {
                                return (
                                  <Typography
                                    key={index}
                                    size="p"
                                    text={element}
                                  />
                                );
                              })}
                            </div>
                          )}
                        </div>
                        {elem.poster && (
                          <img
                            src={elem.poster}
                            alt="Image"
                            width="180px"
                            style={{ marginLeft: '32px' }}
                          />
                        )}
                      </div>
                    )}
                    {elem.isEasyAction ? children : null}
                    <div
                      style={{
                        display: 'flex',
                        justifyContent:
                          elem.size === 'half' && !elem.icon
                            ? 'flex-end'
                            : 'space-between',
                        alignItems: 'flex-end',
                        marginTop: '16px',
                      }}
                    >
                      {elem.icon && (
                        <Icon
                          icon={elem.icon}
                          size={150}
                          colorPrimary="rgba(217, 217, 217, 1)"
                          colorSecondary="rgba(217, 217, 217, 1)"
                        />
                      )}

                      {elem.linkType === 'button' && (
                        <Styled.Download
                          onClick={() =>
                            window.open(
                              `${elem.buttonPath}`,
                              '_blank', // <- This is what makes it open in a new window.
                            )
                          }
                        >
                          {elem.buttonText}{' '}
                          {elem.buttonIcon && (
                            <Icon
                              icon={elem.buttonIcon}
                              size={24}
                              style={{ marginLeft: '8px' }}
                              colorPrimary="black"
                              colorSecondary="black"
                            />
                          )}
                        </Styled.Download>
                      )}
                      {elem.linkType === 'externalLink' && (
                        <a
                          style={{
                            color: 'black',
                            textDecoration: 'dotted underline gray 1px',
                            textUnderlineOffset: '2px',
                            fontWeight: 600,
                            fontSize: '20px',
                            textAlign: 'right',
                            flex: elem.size === 'half' ? '0 1 50%' : '11 100%',
                          }}
                          href={elem.buttonPath}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {elem.buttonText}
                        </a>
                      )}
                      {elem.linkType === 'internalLink' && (
                        <Link
                          style={{
                            color: 'black',
                            textDecoration: 'dotted underline gray 1px',
                            textUnderlineOffset: '2px',
                            fontWeight: 600,
                            fontSize: '20px',
                            textAlign: 'right',
                            flex: elem.size === 'half' ? '0 1 50%' : '11 100%',
                          }}
                          to={elem.buttonPath}
                        >
                          {elem.buttonText}
                        </Link>
                      )}
                      {elem.poster && elem.size === 'full' && (
                        <img src={elem.poster} alt="Image" width="180px" />
                      )}
                    </div>
                  </Styled.Box>
                </Col>
              );
            })}
          </Row>
          <Col md={4} sm={12} xs={12}>
            {el.poster === '' ? null : <Styled.ImgWrap></Styled.ImgWrap>}
          </Col>
        </div>
      );
    });
  };

  return <div>{renderPage()}</div>;
};

export default EasyWin;
